export default "__VITE_ASSET__BkuFuBs4__"